import CardHomeScreen from "./CardsHomeScreen";
import CardAddNewScreen from "./CardsAddNewScreen";
import CardRemoveScreen from "./CardsRemoveScreen";
import { createStackNavigator } from "@react-navigation/stack";
import CardAddErrorNotificationScreen from "../Notifications/cardAddErrorNotification";
import React from "react";

const Stack = createStackNavigator();

export default function cardsNavigationStack() {
    return (
        <>
            <Stack.Screen
                name="CardsHome"
                component={CardHomeScreen}
                options={{ headerShown: false }}
              />
              <Stack.Screen
                name="CardsAddNew"
                component={CardAddNewScreen}
                options={{ headerShown: false }}
              />
              <Stack.Screen
                name="CardsAddError"
                component={CardAddErrorNotificationScreen}
                options={{ headerShown: false }}
              />
              <Stack.Screen
               name="CardsRemove"
               component={CardRemoveScreen}
               options={{ headerShown: false }}
             />
        </>
    )
}